import { useCallback, useEffect, useRef } from 'react';

const useDebounce = () => {
  const timeout = useRef<NodeJS.Timeout>();

  const debounce = useCallback((func: Function, wait: number) => (...args: any) => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => func(...args), wait);
  }, []);

  useEffect(() => () => {
    if (!timeout.current) return;
    clearTimeout(timeout.current);
  }, []);

  return { debounce };
};

export default useDebounce;
